import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home/Vector.png'
import _imports_1 from '@/assets/home/header_1.png'
import _imports_2 from '@/assets/home/header_2.png'
import _imports_3 from '@/assets/aboutUs.png'
import _imports_4 from '@/assets/phone2/header_1.png'
import _imports_5 from '@/assets/phone2/i_logo_1.png'
import _imports_6 from '@/assets/phone2/header_2.png'
import _imports_7 from '@/assets/phone2/header_3.png'
import _imports_8 from '@/assets/phone2/i_logo_2.png'


const _withScopeId = n => (_pushScopeId("data-v-5d976872"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = { class: "banner other" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20%"} }, null, -1))
const _hoisted_4 = { class: "page_nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "f_14 paddingL10" }, "系统登录", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "banner",
  id: "homeBanner"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_1
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20%"} }, null, -1))
const _hoisted_13 = { class: "page_nav" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "f_14 paddingL10" }, "系统登录", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text fontH1" }, "企业员工入职背景调查", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text fontH2" }, "职者有信，选才无忧", -1))
const _hoisted_21 = {
  key: 1,
  class: "banner",
  id: "homeBanner"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_2
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20%"} }, null, -1))
const _hoisted_24 = { class: "page_nav" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "f_14 paddingL10" }, "系统登录", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slogan2" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"20%"} }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "text fontH1" }, "灵活专业的背调解决方案"),
    /*#__PURE__*/_createElementVNode("div", { class: "text fontH2" }, "针对不同职位候选人定制，灵活选择")
  ])
], -1))
const _hoisted_31 = {
  key: 2,
  class: "banner",
  id: "homeBanner"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_3
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20%"} }, null, -1))
const _hoisted_34 = { class: "page_nav" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "f_14 paddingL10" }, "系统登录", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slogan2" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"20%"} }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "text fontH1" }, "企业员工"),
    /*#__PURE__*/_createElementVNode("div", { class: "text fontH2" }, "全生命周期管理系统")
  ])
], -1))
const _hoisted_41 = {
  key: 1,
  class: "p_header",
  id: "p_header"
}
const _hoisted_42 = {
  key: 0,
  class: "banner",
  id: "homeBanner"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_4
}, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_5
}, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-sanheng" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slogan" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fontH1 text" }, "企业员工入职背景调查"),
  /*#__PURE__*/_createElementVNode("div", { class: "fontH2 text" }, "职者有信，选才无忧")
], -1))
const _hoisted_49 = {
  key: 1,
  class: "banner",
  id: "homeBanner"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_6
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_5
}, null, -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-sanheng" }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slogan2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fontH1 text" }, "灵活专业的背调解决方案"),
  /*#__PURE__*/_createElementVNode("div", { class: "fontH2 text" }, "针对不同职位候选人定制，灵活选择")
], -1))
const _hoisted_56 = {
  key: 2,
  class: "banner",
  id: "homeBanner"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_7
}, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_5
}, null, -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-sanheng" }, null, -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slogan2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fontH1 text" }, "企业员工"),
  /*#__PURE__*/_createElementVNode("div", { class: "fontH2 text" }, "全生命周期管理系统")
], -1))
const _hoisted_63 = ["id"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_8
}, null, -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-cuocha" }, null, -1))
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "背调方案"),
  /*#__PURE__*/_createElementVNode("div", { class: "iconfont icon-youjiantou" })
], -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "关于我们"),
  /*#__PURE__*/_createElementVNode("div", { class: "iconfont icon-youjiantou" })
], -1))
const _hoisted_72 = [
  _hoisted_71
]

import { ref, getCurrentInstance, onMounted, toRefs, watch, nextTick, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
  activeRoute: {
    type: String,
    default: "home",
  },
  scrollTurn: {
    type: Boolean,
    default: false,
  },
},
  emits: ["updateScroll"],
  setup(__props, { emit }: { emit: ({
  (e: "updateScroll", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const { $utils } = getCurrentInstance()!.appContext.config.globalProperties;

const route = useRoute();
const router = useRouter();


let activeHeader = ref("home");
let visible = ref(false); //抽屉

//  手机端抽屉
const openDrawer = (item: any) => {
  visible.value = true;
};
watch(
  () => props.activeRoute,
  (value) => {
    switch (value) {
      case "scheme":
      case "aboutUs":
      case "other":
        activeHeader.value = value;
        break;
      case "surveyDetails":
      case "apiServe":
      case "flowPath":
        activeHeader.value = "other";
        break;
      default:
        activeHeader.value = "home";
        break;
    }
  },
  { immediate: true }
);
let list = [
  { title: "首页", type: 1, route: "home", path: "/home" },
  { title: "背调方案", type: 2, route: "scheme", path: "/scheme" },
  { title: "背调项目", type: 3, route: "surveyDetails", path: "/surveyDetails" },
  { title: "核心价值", type: 4, route: "apiServe", path: "/apiServe" },
  { title: "背调流程", type: 5, route: "flowPath", path: "/flowPath" },
  { title: "关于我们", type: 7, route: "aboutUs", path: "/aboutUs" },
];
// 路由跳转
const toRoute = (key) => {
  for (const i in list) {
    let item = list[i];
    if (key == item.type) {
      if (item.route == route.name) {
        return;
      }
      router.push(item.path);
      nextTick(() => {
        emit("updateScroll", "1");
        visible.value = false;
      });
    }
  }
};

const toLogin = () => {
  let url = location.protocol + "//" + location.host + "/pc/index.html#/login";
  // location.href = "https://devyc.zecaimao.cn/pc/index.html#/login";
  location.href = url;
};

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref($utils).isMobile())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
            }, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
                    onClick: ($event: any) => (toRoute(item.type))
                  }, _toDisplayString(item.title), 11, _hoisted_6))
                }), 128))
              ]),
              _createElementVNode("div", { class: "link_nav" }, [
                _hoisted_7,
                _createElementVNode("div", {
                  onClick: toLogin,
                  class: "iconfont icon-yonghu login"
                }, _hoisted_9)
              ])
            ], 2)
          ], 512), [
            [_vShow, _unref(activeHeader) == 'other']
          ]),
          (_unref(activeHeader)== 'home')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", {
                  class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
                }, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
                        onClick: ($event: any) => (toRoute(item.type))
                      }, _toDisplayString(item.title), 11, _hoisted_15))
                    }), 128))
                  ]),
                  _createElementVNode("div", { class: "link_nav" }, [
                    _hoisted_16,
                    _createElementVNode("div", {
                      onClick: toLogin,
                      class: "iconfont icon-yonghu login"
                    }, _hoisted_18)
                  ])
                ], 2),
                _createElementVNode("div", { class: "slogan" }, [
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("div", {
                    class: "exp_now",
                    onClick: toLogin
                  }, "立即使用")
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(activeHeader)== 'scheme')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", {
                  class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
                }, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
                        onClick: ($event: any) => (toRoute(item.type))
                      }, _toDisplayString(item.title), 11, _hoisted_26))
                    }), 128))
                  ]),
                  _createElementVNode("div", { class: "link_nav" }, [
                    _hoisted_27,
                    _createElementVNode("div", {
                      onClick: toLogin,
                      class: "iconfont icon-yonghu login"
                    }, _hoisted_29)
                  ])
                ], 2),
                _hoisted_30
              ]))
            : _createCommentVNode("", true),
          (_unref(activeHeader)== 'aboutUs')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", {
                  class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
                }, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["pointer select_none", item.route == _unref(route).name ? 'active': '']),
                        onClick: ($event: any) => (toRoute(item.type))
                      }, _toDisplayString(item.title), 11, _hoisted_36))
                    }), 128))
                  ]),
                  _createElementVNode("div", { class: "link_nav" }, [
                    _hoisted_37,
                    _createElementVNode("div", {
                      onClick: toLogin,
                      class: "iconfont icon-yonghu login"
                    }, _hoisted_39)
                  ])
                ], 2),
                _hoisted_40
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref($utils).isMobile())
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          (_unref(activeHeader)== 'home')
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", {
                  class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
                }, [
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (toRoute(1)))
                  }, _hoisted_45),
                  _createElementVNode("div", {
                    class: "sanheng",
                    onClick: openDrawer
                  }, _hoisted_47)
                ], 2),
                _hoisted_48
              ]))
            : _createCommentVNode("", true),
          (_unref(activeHeader)== 'scheme')
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", {
                  class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
                }, [
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toRoute(1)))
                  }, _hoisted_52),
                  _createElementVNode("div", {
                    class: "",
                    onClick: openDrawer
                  }, _hoisted_54)
                ], 2),
                _hoisted_55
              ]))
            : _createCommentVNode("", true),
          (_unref(activeHeader)== 'aboutUs')
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", {
                  class: _normalizeClass(["nav", __props.scrollTurn ? 'banner_fix' : ''])
                }, [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (toRoute(1)))
                  }, _hoisted_59),
                  _createElementVNode("div", {
                    class: "",
                    onClick: openDrawer
                  }, _hoisted_61)
                ], 2),
                _hoisted_62
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_drawer, {
      class: "drawer_class",
      size: 180,
      modelValue: _unref(visible),
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
      direction: 'ttb',
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["textLeft", titleClass]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (toRoute(1))),
          id: titleId
        }, _hoisted_65, 10, _hoisted_63),
        _createElementVNode("div", {
          class: "cuocha",
          onClick: close
        }, _hoisted_68, 8, _hoisted_66)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "row",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (toRoute(2)))
        }, _hoisted_70),
        _createElementVNode("div", {
          class: "row",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (toRoute(7)))
        }, _hoisted_72)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})